import { ColumnData } from "../../../../assets/types/ColumnData";
import { Chip } from "@mui/material";

type ChipColor = "default" | "success" | "error" | "warning" | "info";

// Map an order status to a chip colour.
const statusColor = (status?: string): ChipColor => {
	const s = (status || "").toLowerCase();
	if (s === "confirmed" || s === "delivered" || s === "fulfilled") {
		return "success";
	}
	if (s.includes("cancel") || s === "expired" || s.startsWith("rto")) {
		return "error";
	}
	if (s === "pending") return "warning";
	return "info";
};

const columns: ColumnData[] = [
	{
		headerName: "Order ID",
		field: "orderId",
		renderCell: ({ row }) => <>{row.orderId}</>,
	},
	{
		headerName: "Products",
		field: "productName",
		renderCell: ({ row }) => <>{row.productName}</>,
	},
	{
		headerName: "Payment Mode",
		field: "mode",
		renderCell: ({ row }) => <>{row.mode}</>,
	},
	{
		headerName: "Amount",
		field: "mrp",
		renderCell: ({ row }) => <>{row.mrp}</>,
	},
	{
		headerName: "Status",
		field: "status",
		renderCell: ({ row }) => (
			<Chip
				label={row.status || "-"}
				color={statusColor(row.status)}
				size="small"
			/>
		),
	},
	{
		headerName: "Order Date",
		field: "orderDate",
		renderCell: ({ row }) => <>{row.orderDate}</>,
	},
];

const dataTableData = {
	columns,
};

export default dataTableData;
